/**
 * Tracking utilities for Google Tag Manager, Google Ads, and Meta Pixel
 */

declare global {
  interface Window {
    dataLayer?: unknown[];
    fbq?: (...args: unknown[]) => void;
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Push a custom event to Google Tag Manager dataLayer
 */
export const trackGTMEvent = (event: string, data?: Record<string, unknown>) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event,
      ...data,
    });
  }
};

/**
 * Track a conversion event for Google Ads via GTM
 */
export const trackGoogleAdsConversion = (conversionLabel: string, value?: number) => {
  trackGTMEvent('conversion', {
    send_to: conversionLabel,
    value: value ?? 0,
    currency: 'EUR',
  });
};

/**
 * Track a custom event with Meta Pixel (Facebook)
 */
export const trackMetaPixelEvent = (eventName: string, params?: Record<string, unknown>) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

/**
 * Track form submission (lead generation)
 */
export const trackLeadSubmission = (leadData?: { email?: string; name?: string }) => {
  // GTM event
  trackGTMEvent('lead_submit', {
    event_category: 'Lead',
    event_label: 'Form Submission',
    ...leadData,
  });

  // Meta Pixel Lead event
  trackMetaPixelEvent('Lead', leadData);

  // Google Ads conversion (sostituisci con il tuo conversion label)
  // trackGoogleAdsConversion('AW-XXXXXXXXX/YYYYYYYYYY');
};

/**
 * Track page view (useful for SPA navigation)
 */
export const trackPageView = (path: string, title?: string) => {
  trackGTMEvent('page_view', {
    page_path: path,
    page_title: title ?? document.title,
  });

  // Meta Pixel PageView
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};
